import { Search, X } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

interface SearchQueryProps {
  onChange: (_value: string) => void
  placeholder: string
}

export const SearchQuery = ({ onChange, placeholder }: SearchQueryProps) => {
  const [text, setText] = useState('')
  return (
    <div className="relative min-w-[240px] flex-1">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        className="bg-white pl-9 pr-4"
        onChange={(e) => {
          onChange(e.target.value)
          setText(e.target.value)
        }}
        placeholder={placeholder}
        value={text}
      />
      {text && (
        <Button
          className="absolute right-1 top-1.5 h-7 w-7"
          onClick={() => {
            setText('')
            onChange('')
          }}
          size="icon"
          variant="ghost"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
